import { isRequired, createValidator } from 'app/validators/base'

const validate = isRequired(value => (typeof value === 'string' ? value.trim() : value))

export default createValidator(validate, 'level')
